module.exports = __webpack_public_path__ + "static/media/wind_speed_comparative_per_day.e4d30c23.svg";